'use strict';

var $       = require('jquery');
var Core    = require('../core/core.js');

/**
 * Creates a interactive window object
 *
 * @class
 */

class WindowListItem extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'leftIcon': false,
                'leftIconToggle': false,
                'title': '',
                'rightIcon': false,
                'rightIconToggle': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__window__listitem clearfix'>
                <% if(leftIcon){ %>
                    <a class='js-editor__window__listitem__lefticon'>
                        <div class='editor__window__listitem__lefticon editor__window__listitem__icon cio-ui-icon float'>
                            <%= embedded_svg(leftIcon) %>
                        </div>
                    </a>
                <% } if(leftIconToggle){ %>
                    <a class='js-editor__window__listitem__lefticon__toggle hide'>
                        <div class='editor__window__listitem__lefticon__toggle editor__window__listitem__icon cio-ui-icon float'>
                            <%= embedded_svg(leftIconToggle) %>
                        </div>
                    </a>
                <% } %>

                <div class='editor__window__listitem__title float'><%- title %></div>

                <% if(rightIcon){ %>
                    <a class='js-editor__window__listitem__righticon'>
                        <div class='editor__window__listitem__righticon cio-ui-icon editor__window__listitem__icon right'>
                            <%= embedded_svg(rightIcon) %>
                        </div>
                    </a>
                <% } if(rightIconToggle){ %>
                    <a class='js-editor__window__listitem__righticon__toggle hide'>
                        <div class='editor__window__listitem__righticon__toggle editor__window__listitem__icon cio-ui-icon right'>
                            <%= embedded_svg(rightIconToggle) %>
                        </div>
                    </a>
                <% } %>
            </div>
        `;

        super.render();

        /**
         * Click left icon event
         *
         * @fires WindowListItem#_leftIconClicked
         */

         $('.js-editor__window__listitem__lefticon', this.$el).on('click', this._leftIconClicked);

        /**
         * Click left toggle icon event
         *
         * @fires WindowListItem#_leftIconToggleClicked
         */

         $('.js-editor__window__listitem__lefticon__toggle', this.$el).on('click', this._leftIconToggleClicked);

        /**
         * Click right icon event
         *
         * @fires WindowListItem#_rightIconClicked
         */

         $('.js-editor__window__listitem__righticon', this.$el).on('click', this._rightIconClicked);

        /**
         * Click right toggle icon event
         *
         * @fires WindowListItem#_rightIconToggleClicked
         */

         $('.js-editor__window__listitem__righticon__toggle', this.$el).on('click', this._rightIconToggleClicked);
    }

    /**
     * @event WindowListItem#Cioui:WindowListItem:leftIconClick
     * @property {String}Cioui:WindowListItem:leftIconClick
     * @returns {Object} event - native click Event
     */

    _leftIconClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowListItem:leftIconClick', e);
    }

    /**
     * @event WindowListItem#Cioui:WindowListItem:leftIconToggleClick
     * @property {String}Cioui:WindowListItem:leftIconToggleClick
     * @returns {Object} event - native click Event
     */

    _leftIconToggleClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowListItem:leftIconToggleClick', e);
    }

    /**
     * @event WindowListItem#Cioui:WindowListItem:rightIconClick
     * @property {String}Cioui:WindowListItem:rightIconClick
     * @returns {Object} event - native click Event
     */

    _rightIconClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowListItem:rightIconClick', e);
    }

    /**
     * @event WindowListItem#Cioui:WindowListItem:rightIconToggleClick
     * @property {String}Cioui:WindowListItem:rightIconToggleClick
     * @returns {Object} event - native click Event
     */

    _rightIconToggleClicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:WindowListItem:rightIconToggleClick', e);
    }

    /**
     * left Icon Active
     * makes the left icon active
     */
    leftIconActive(){
        $('.js-editor__window__listitem__lefticon', this.$el).show();
        $('.js-editor__window__listitem__lefticon__toggle', this.$el).hide();
    }

    /**
     * left toggle Icon Active
     * makes the left toggle icon active
     */
    leftIconInactive(){
        $('.js-editor__window__listitem__lefticon', this.$el).hide();
        $('.js-editor__window__listitem__lefticon__toggle', this.$el).show();
    }

    /**
     * left Icon Active
     * makes the left icon active
     */
    rightIconActive(){
        $('.js-editor__window__listitem__righticon', this.$el).show();
        $('.js-editor__window__listitem__righticon__toggle', this.$el).hide();
    }

    /**
     * right toggle Icon Active
     * makes the right toggle icon active
     */
    rightIconInactive(){
        $('.js-editor__window__listitem__righticon', this.$el).hide();
        $('.js-editor__window__listitem__righticon__toggle', this.$el).show();
    }
}
module.exports = WindowListItem;